import { useEffect, useState } from 'react';
import { CircularProgress, Icon, InputAdornment, TextField } from '@mui/material';

import useDebounce from 'Lib/hooks/useDebounce';
import isEmpty from 'Lib/utilities/isEmpty';
import isNil from 'Lib/utilities/isNil';

/**
 * Search input component with debounced onChange
 * @deprecated Use the Trellis Input.Search component instead: https://main--6710219e5989b079dbcc9421.chromatic.com/?path=/docs/components-input-search--docs
 */
const SearchInput = ({ isLoading = false, onChange, sx, ...rest }) => {
	const [value, setValue] = useState(null);

	const searchInput = useDebounce(value, 500);

	useEffect(() => {
		if (!isNil(value)) {
			onChange(searchInput);
		}
	}, [searchInput]);

	const handleInputChange = event => {
		setValue(event.target.value);
	};

	return (
		<TextField
			{...rest}
			autoFocus
			autoComplete="false"
			id="search-input"
			data-testid="search-input"
			variant="outlined"
			color="success"
			value={value || ''}
			sx={{ borderRadius: 2, mt: 2, mb: 4, width: '100%', ...sx }}
			onChange={handleInputChange}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<Icon>search</Icon>
					</InputAdornment>
				),
				endAdornment: isLoading ? (
					<InputAdornment position="end">
						<CircularProgress size={20} />
					</InputAdornment>
				) : !isEmpty(value) ? (
					<InputAdornment position="end" onClick={() => setValue('')} sx={{ '&:hover': { cursor: 'pointer' } }}>
						<Icon>cancel</Icon>
					</InputAdornment>
				) : null
			}}
		/>
	);
};

export default SearchInput;
